<template>
  <!-- 页脚 -->
  <div class="footer other_99 wow slideInUp">
    <div class="wrapper">
      <div class="qr">
        <img class="logo2" src="../../assets/imgs/llogo2.png" alt="" />
        <div class="gzh">
          <!-- <p>集团公众号</p>
          <div class="ewm">
            <img src="../../assets/images/gongzhonghao.png" alt="" />
          </div> -->
          <ul>
            <li v-for="item in arrList" :key="item.id" @click="templatesDetailOrLink(item.content,item.category,item.currentRowId)">{{ item.title }}</li>
          </ul>
        </div>
      </div>
      <div class="lianxi">
        <p v-for="textList in bottomTextList" :key="textList.id">{{ textList.title }}：{{textList.content}}</p>
      </div>
      <div class="weixin" v-for="urlList in bottomUrlList" :key="urlList.id">
        <p><img :src="urlList.content" alt="" class="weixinImg"/></p>
        <p>{{ urlList.title }}</p>
      </div>
      <!-- <div class="weixin" v-for="urlList in bottomUrlList" :key="urlList.id">
        <p><img src="../../assets/imgs/footer/03.png" alt="" class="weixinImg"/></p>
        <p>{{ urlList.title }}</p>
      </div> -->
    </div>
    <div class="bottom">
      <p @click="to">{{ $t('footer.1-10') }}</p>
    </div>
  </div>
</template>

<script>
import { bottomList } from '@/api/index.js'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      logo: null,
      lang: 1,
      flag: true,
      type: 1,
      pmwidth: null,
      category: null,
      arrList: [],
      bottomTextList: [],
      bottomSrcList: [],
      bottomTemplateList: [],
      bottomUrlList: [],
      client: 0
    }
  },
  methods: {
    handleScroll() {
      // 头部滚动背景色
      const footer = document.querySelector('.footer')
      if (document.body.clientWidth < 1200) {
        return footer.classList.add('footer-bg')
      }
      if (window.pageYOffset > 200) {
        footer.style.visibility = 'visible'
        footer.classList.add('footer-bg')
      } else {
        footer.classList.remove('footer-bg')
      }
    },
    async getBottomList() {
      if (this.type === 'zh' || this.type === 1) {
        this.type = 1
      } else {
        this.type = 2
      }
      const data1 = await bottomList({ type: this.type, category: 1 })
      const data2 = await bottomList({ type: this.type, category: 2 })
      const data3 = await bottomList({ type: this.type, category: 3 })
      const data4 = await bottomList({ type: this.type, category: 4 })

      this.bottomTextList = data1.data.list
      const textArr = data2.data.list
      const templateArr = data3.data.list
      const arrList = []
      textArr.forEach((item) => {
        arrList.push(item)
      })
      templateArr.forEach(item => {
        arrList.push(item)
      })
      this.arrList = arrList
      this.bottomUrlList = data4.data.list
    },
    async templatesDetailOrLink(content, category, currentRowId) {
      if (category == 2) {
        return window.open(content)
      } else if (category == 3) {
        this.$router.push({ path: '/tohome', query: { currentRowId: currentRowId } })
      }
    },
    to() {
      window.open('https://beian.miit.gov.cn/')
    }
  },

  mounted() {
    this.logo = localStorage.getItem('logo')
    this.$bus.$on('lang', (lang) => {
      this.type = lang
      this.getBottomList()
    })
    this.getBottomList()
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
      // this.WheelGo()
    })
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
// 页脚
.footer-bg {
  position: fixed;
  bottom: 0;
  z-index: 99999;
  width: 100%;
  height: 180px !important;
  opacity: .8;
  // @media screen and (max-width: 1200px) {
  //   height: 190px !important;
  // }
}
.footer {
  background-color: #112945;
  box-sizing: border-box;
  // height: 0;
  .wrapper {
    background-color: #112945;
    width: 1400px;
    height: 150px;
    box-sizing: border-box;
    padding-top: 20px;
    padding-left: 40px;
    margin: 0 auto;
    display: flex;
    position: relative;
    justify-content: space-around;
    // @media screen and (max-width: 475px) {
    //   box-sizing: border-box;
    //   width: 100%;
    //   height: 320px;
    //   box-sizing: border-box;
    //   padding-top: 10px;
    //   padding-left: 10px;
    //   margin: 0 auto;
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    //   position: relative;
    // }
    .qr {
      // display: flex;
      // flex-direction: column;
      .gzh {
        display: flex;
        color: #5d6faf;
        font-size: 14px;
        margin-top: 30px;
        line-height: 25px;
        img {
          width: 100px;
          height: 100px;
          margin-left: 25px;
        }
        ul {
          display: flex;
          li {
            padding: 0 10px;
            height: 12px;
            line-height: 12px;
            border-right: 1px solid #eee;
            color: #789ab2;
            font-size: 16px;
            cursor: pointer;
            @media screen and (max-width: 1200px) {
              font-size: 20px;
            }
            &:hover {
              color: #26aaff;
            }
          }
        }
      }
    }
    .lianxi {
      font-size: 15px;
      font-weight: 200;
      line-height: 31px;
      margin-left: 30px;
      h5 {
        color: #fff;
        font-weight: 200;
      }
      p {
        color: #a7b2d1;
        @media screen and (max-width: 1200px) {
          font-size: 22px;
        }
      }
    }
    .weixin {
      color: #a7b2d1;
      position: relative;
      top: -20px;
      left: 50px;
      &:last-child {
        margin-left: -80px;
        @media screen and (max-width: 1200px) {
          margin-left: 0;
        }
      }
      img {
        width: 100px;
        height: 100px;
      }
      .weixinImg {
        &:hover {
          transform: rotate(360deg);
          transition: 2s all;
        }
      }
      p {
        width: 100px;
        font-size: 16px;
        text-align: center;
        margin: 10px 0;
        @media screen and (max-width: 1200px) {
          font-size: 22px;
        }
      }
    }
    .logo2 {
      width: 450px;
      height: 60px;
      margin: 5px 60px -20px 5px;
      @media screen and (max-width: 1200px) {
        width: 450px;
        height: 60px;
      }
    }
    ul {
      @media screen and (max-width: 420px) {
        display: none;
      }
      h4 {
        font-size: 16px;
        color: #e0e1e3;
        padding-bottom: 10px;
        padding-right: 15px;
        border-bottom: 1px solid #7e7e7e;
      }
      li {
        font-size: 12px;
        color: #979ba2;
        margin: 14px 0;
        // @media screen and (max-width: 420px) {
        //   display: none;
        // }
      }
    }
    .dizhi {
      // @media screen and (max-width: 420px) {
      //   display: block;
      // }
    }
  }
  .bottom {
    min-width: 1400px;
    line-height: 35px;
    height: 40px;
    // padding: 10px 0;
    box-sizing: border-box;
    text-align: center;
    background-color: #273365;
    color: #e0e1e3;
    font-size: 16px;
    font-weight: 200;
    // @media screen and (max-width: 420px) {
    //   height: 40px;
    //   line-height: 20px;
    //   text-align: center;
    //   background-color: #273365;
    //   color: #e0e1e3;
    //   font-size: 12px;
    // }
    p {
      width: 85%;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .us {
    margin-right: 90px;
    li {
      a:hover {
        cursor: pointer;
        font-weight: 700;
        color: #fff;
      }
    }
  }
}
</style>
